<div class="call-to-action-container">
    <h1>Suas obras, dentro do orçamento!</h1>
    <button>Inicie agora mesmo</button>
</div>